export default "../css/86c330c66f7333ff6202209becd04687.ttf";